import BaseDecorator from "./BaseDecorator";

export default class OrderItemDecorator extends BaseDecorator {
  get is_new_custom_item() {
    return !this.id && this.item_type === "product_custom";
  }

  get total_price() {
    return (
      this.unit_price && {
        value: this.quantity * this.unit_price.value,
        currency: this.unit_price.currency,
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/OrderItemDecorator.js